import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { retry, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { Usuario } from "../entidades/usuario";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class UsuarioService {
  constructor(private http: HttpClient) {}

  opcionesHttp = {
    headers: new HttpHeaders({
      "Content-Type": "application/json"
    })
  };

  crearUsuario(usuario): Observable<any> {
    return this.http
      .post<Usuario>(environment.apiUrl + "/Usuarios/crear", JSON.stringify(usuario), this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  /* Consulta los conflictos existentes para un usuario especifico para la vista de resumen **/
  ConsultarConflictosUsuario(usuario): Observable<any> {
    return this.http
      .post<Usuario>(environment.apiUrl + "/Usuarios/consultar-conflictos", JSON.stringify(usuario), this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  editarUsuario(usuario): Observable<any> {
    return this.http
      .post<Usuario>(environment.apiUrl + "/Usuarios/editar", JSON.stringify(usuario), this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }

  obtenerLista(columna): Observable<any> {
    return this.http
      .get<Usuario>(environment.apiUrl + `/Usuarios/lista/${columna}`, this.opcionesHttp)
      .pipe(
        retry(1),
        catchError(this.manejarError)
      );
  }
  /*
  obtenerLista(columna) {
    let Data = {
      columna 
    };
    return this.http.post(`${environment.apiUrl}/Usuarios/lista`, Data);
  }*/

  manejarError(error) {
    let mensajeError = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      mensajeError = error.error.message;
    } else {
      // Get server-side error
      mensajeError = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(mensajeError);
    return throwError(mensajeError);
  }
}
